import React, { useContext, createContext, useState } from 'react';
const OvertimeContext = createContext();

export function OvertimeProvider({ children }) {
    const [overtime, setOvertime] = useState(false)
    const [playTimer, setPlay] = useState(false)

    const triggerOvertime = () => {
        setOvertime(true)
    }

    return <OvertimeContext.Provider value={{
        triggerOvertime,
        setPlay,
        playTimer,
        overtime
    }}>
        {children}
        </OvertimeContext.Provider>
}

export const useOvertime = () => useContext(OvertimeContext)